/********* LIST *********/

export const GET_DEALER_GROUP_REGION_LIST = 'GET_DEALER_GROUP_REGION_LIST'
export const GET_DEALER_REGION_LIST_OK = 'GET_DEALER_REGION_LIST_OK'
export const GET_DEALER_REGION_LIST_ERR = 'GET_DEALER_REGION_LIST_ERR'
export const DO_DEALER_REGION_LIST_CLEANUP = 'DO_DEALER_REGION_LIST_CLEANUP'